function text(value) {
  return value == null ? '' : String(value).trim()
}

// The course-feed contract has used all of these fields across snapshots.  Do
// not rely only on the optional boolean: older persisted courses and some live
// rows identify an asynchronous class by its category/class type instead.
function legacyOnlineMetadata(value) {
  const valueText = text(value)
  return /이러닝|온라인/i.test(valueText)
    || /(?:^|[\s/_-])(?:e-?learning|online|asynchronous)(?:$|[\s/_-])/i.test(valueText)
}

// Legacy records predate the canonical boolean.  This is intentionally a
// normalization-boundary concern: never infer online status from the title.
export function normalizeCourseIsOnline(course = {}) {
  if (typeof course.isOnline === 'boolean') return course.isOnline
  return [
    course.category,
    course.type,
    course.classType,
    course.deliveryType,
    course.deliveryMethod,
    course.method,
  ].some(legacyOnlineMetadata)
}

// All post-normalization consumers use only the canonical boolean.
export function isOnlineCourse(course = {}) {
  return course.isOnline === true
}

export const isElearningCourse = isOnlineCourse

/** Online courses are never time-grid courses, regardless of their schedule metadata. */
export function getCourseScheduleMode(course = {}) {
  return isOnlineCourse(course) ? 'online' : 'offline'
}
